export default __webpack_public_path__ + "static/media/googlePlayWhite.8725e54b.svg";